import EditIcon from "@mui/icons-material/Edit";
import { Grid2, IconButton } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { SectionGap } from "../../../models/Section";

type Props = {
	setOpenEdit: (open: boolean) => void;
	setSelectedData?: (data: any) => void;
};

export const useSectionsGapsGridData = ({
	setOpenEdit,
	setSelectedData = () => {},
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "StandName",
			headerName: "Stand",
			flex: 1,
		},
		{
			field: "SetpointGap",
			headerName: "Setpoint Gap",
			flex: 1,
		},
		{
			field: "Comments",
			headerName: "Comments",
			flex: 3,
		},
		{
			field: "-",
			cellRenderer: (params: ICellRendererParams) => (
				<Grid2
					container
					sx={{
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						opacity: 0,
						transition: "opacity 0.1s ease-in-out",
					}}
					className={`buttons`}
				>
					<Grid2
						size={{ xs: 12, md: 12 }}
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<IconButton
							onClick={() => {
								setOpenEdit(true);
								setSelectedData(params.data as SectionGap);
							}}
							title="Edit"
							size="small"
						>
							<EditIcon
								style={{ height: "auto" }}
								color="primary"
								fontSize="small"
							/>
						</IconButton>
					</Grid2>
				</Grid2>
			),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 50,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
